const R = 150;
const polar = (deg, r = R) => {
  const a = ((deg - 90) * Math.PI) / 180;
  return [R + r * Math.cos(a), R + r * Math.sin(a)];
};
const isLight = (hex) => {
  const n = parseInt(hex.replace("#", ""), 16);
  return ((n >> 16) * 299 + ((n >> 8) & 255) * 587 + (n & 255) * 114) / 1000 > 160;
};

export const segmentsOf = (prizes) => {
  let start = 0;
  return prizes.filter((p) => p.probability > 0).map((p) => {
    const sweep = p.probability * 3.6;
    const seg = { ...p, start, end: start + sweep };
    start += sweep;
    return seg;
  });
};

export default function SpinWheel({ prizes, rotation, spinning }) {
  const segs = segmentsOf(prizes);
  return (
    <div className="relative w-[280px] h-[280px] sm:w-[340px] sm:h-[340px]" data-testid="spin-wheel">
      <div className="absolute left-1/2 -top-3 -translate-x-1/2 z-10 drop-shadow-lg" data-testid="spin-pointer">
        <svg width="34" height="40" viewBox="0 0 34 40"><path d="M17 40 L2 8 A16 16 0 1 1 32 8 Z" fill="#FF6600" stroke="#fff" strokeWidth="3" /></svg>
      </div>
      <div className="absolute inset-0 rounded-full shadow-[0_0_0_10px_#111111,0_0_0_14px_#FF6600,0_20px_50px_rgba(0,0,0,0.35)]" />
      <svg viewBox="0 0 300 300" className="relative w-full h-full rounded-full"
        style={{ transform: `rotate(${rotation}deg)`, transition: spinning ? "transform 5.5s cubic-bezier(0.12, 0.8, 0.12, 1)" : "none" }}>
        {segs.map((s) => {
          const [x1, y1] = polar(s.start);
          const [x2, y2] = polar(s.end);
          const large = s.end - s.start > 180 ? 1 : 0;
          const mid = (s.start + s.end) / 2;
          const [tx, ty] = polar(mid, R * 0.6);
          const fs = s.end - s.start < 25 ? 8 : 10.5;
          return (
            <g key={s.id}>
              <path d={`M${R},${R} L${x1},${y1} A${R},${R} 0 ${large} 1 ${x2},${y2} Z`} fill={s.color} stroke="#fff" strokeWidth="1.5" />
              <text x={tx} y={ty} fill={isLight(s.color) ? "#111111" : "#ffffff"} fontSize={fs} fontWeight="800" textAnchor="middle"
                dominantBaseline="middle" transform={`rotate(${mid > 180 ? mid + 90 : mid - 90} ${tx} ${ty})`} style={{ fontFamily: "Arial, sans-serif" }}>
                {s.label.length > 14 ? s.label.split(" ").slice(0, 2).join(" ") : s.label}
                {s.label.length > 14 && <tspan x={tx} dy={fs + 1}>{s.label.split(" ").slice(2).join(" ")}</tspan>}
              </text>
            </g>
          );
        })}
        <circle cx={R} cy={R} r="30" fill="#111111" stroke="#FF6600" strokeWidth="4" />
        <image href="/logo192.png" x={R - 22} y={R - 22} width="44" height="44" />
      </svg>
    </div>
  );
}
